import base64 from 'base-64';

const decode = encodedString =>
  encodedString ? base64.decode(encodedString) : '';

export default decode;
